export default __webpack_public_path__ + "static/media/BCA37.34d7b659.jpg";